module.exports = __webpack_public_path__ + "static/media/bangladesh.05e8826e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/bangladesh.svg
// module id = 376
// module chunks = 1